export default __webpack_public_path__ + "static/media/filter_plus_blue.0d403994.svg";